import { PeriodicReviews } from "./types.ts";

export const VERSIONS = {
  API: 1,
  INTERFACE: 1,
};
export const MAX_NUMBER_OF_RELATIONS = 100;
export const CURRENT_VERSION = 1;
export const FILE_UPLOAD_PREFIX = "file-upload:";
export const languages = ["en", "es", "nl", "fr", "pt", "it", "de", "pl", "ro", "gr"] as const;
export const languageNames: {
  [key in (typeof languages)[number]]: string;
} = {
  en: "English",
  es: "Español",
  fr: "Français",
  nl: "Nederlands",
  pt: "Português",
  it: "Italiano",
  de: "Deutsch",
  pl: "Polski",
  ro: "Română",
  gr: "Ελληνικά",
  //TODO: add new language here
};

export const yesOrNoOptions = [
  { label: { en: "Yes", es: "Sí", fr: "Oui", nl: "Ja", pt: "Sim", it: "Si", de: "Ja", pl: "Tak", ro: "Da", gr: "Ναι" }, value: true }, //TODO: add new language here
  { label: { en: "No", es: "No", fr: "Non", nl: "Nee", pt: "Não", it: "No", de: "Nein", pl: "Nie", ro: "Nu", gr: "Όχι" }, value: false }, //TODO: add new language here
];
export const relationTypeOptions = [
  {
    label: {
      en: "Authorised contact",
      es: "Contacto autorizado",
      fr: "Contacts Autorisés",
      nl: "Geautoriseerd contact",
      pt: "Contato autorizado",
      it: "Contatto autorizzato",
      de: "Autorisierter Kontakt",
      pl: "Autoryzowany kontakt",
      ro: "Persoană de contact autorizată",
      gr: "Εξουσιοδοτημένη Επαφή",
      //TODO: add new language here
    },
    value: "auth contact",
  },
  {
    label: {
      en: "Director",
      es: "Director",
      fr: "Directeur",
      nl: "Directeur",
      pt: "Diretor",
      it: "Direttore",
      de: "Geschäftsführer",
      pl: "Zarząd",
      ro: "Director",
      gr: "Διευθυντής",
      //TODO: add new language here
    },
    value: "director",
  },
  {
    label: {
      en: "Ultimate beneficial owner",
      es: "Titular real",
      fr: "Bénéficiaires Effectives",
      nl: "Uiteindelijke begunstigde eigenaar",
      pt: "Proprietário beneficiário final",
      it: "Titolare Effettivo",
      de: "Wirtschaftlicher Eigentümer",
      pl: "Beneficjent rzeczywisty",
      ro: "Beneficiar real final",
      gr: "Επικαρπωτής",
      //TODO: add new language here
    },
    value: "ubo",
  },
  {
    label: {
      en: "Corporate director",
      es: "Director corporativo",
      fr: "Directeur corporatif",
      nl: "Bedrijfsdirecteur",
      pt: "Empresa como Diretora",
      it: "Direttore aziendale",
      de: "Geschäftsführer",
      pl: "Dyrektor korporacyjny (osoba prawna)",
      ro: "Director corporativ",
      gr: "Εταιρικός διευθυντής",
      //TODO: add new language here
    },
    value: "corporate director",
  },
];
export const secondaryRelationTypeOptions = [
  {
    label: {
      en: "Director",
      es: "Director",
      fr: "Directeur",
      nl: "Directeur",
      pt: "Diretor",
      it: "Direttore",
      de: "Geschäftsführer",
      pl: "Zarząd",
      ro: "Director",
      gr: "Διευθυντής",
      //TODO: add new language here
    },
    value: "director",
  },
  {
    label: {
      en: "Corporate director",
      es: "Director corporativo",
      fr: "Directeur corporatif",
      nl: "Bedrijfsdirecteur",
      pt: "Empresa como Diretora",
      it: "Direttore aziendale",
      de: "Geschäftsführer",
      pl: "Dyrektor korporacyjny (osoba prawna)",
      ro: "Director corporativ",
      gr: "εταιρικός διευθυντής",
      //TODO: add new language here
    },
    value: "corporate director",
  },
];

export const SUCCESS_MESSAGES: PeriodicReviews.WebApp.Messages = {
  AUTHORIZED_AS: {
    en: "Authorized successfully as",
    es: "Autorizado con éxito como",
    nl: "Met succes geautoriseerd als",
    fr: "Autorisé avec succès comme",
    pt: "Autorizado com sucesso como",
    it: "Autorizzato con successo come",
    de: "Erfolgreich autorisiert als",
    pl: "Autoryzowano pomyślnie dla",
    ro: "Autorizat cu succes ca",
    gr: "Εξουσιοδοτήθηκε επιτυχώς",
    //TODO: add new language here
  },
};

export const ERROR_MESSAGES: PeriodicReviews.WebApp.Messages = {
  NO_DATA_FOUND: {
    en: "No data found for the given email and account number. Please use the link provided in the email sent by Ebury",
    es: "No se han encontrado datos para el e-mail y número de cuenta indicados. Por favor, utilice el enlace proporcionado en el e-mail enviado por Ebury.",
    nl: "Geen gegevens gevonden voor het opgegeven e-mailadres en rekeningnummer. Gebruik de link in de e-mail die door Ebury is verzonden.",
    fr: "Aucune donnée trouvée pour l'e-mail et le numéro de compte indiqués. Veuillez utiliser le lien fourni dans l'e-mail envoyé par Ebury.",
    pt: "Não foram encontrados dados para o email e número de conta indicados. Por favor, utilize o link facultado no email enviado pela Ebury",
    it: "Nessun dato trovato per l'e-mail e il numero di account specificati. Utilizza il link fornito nell'e-mail inviata da Ebury",
    de: "Für die angegebene E-Mail-Adresse und Kontonummer wurden keine Daten gefunden. Bitte verwenden Sie den in der von Ebury gesendeten E-Mail bereitgestellten Link.",
    pl: "Nie znaleziono danych dla podanego adresu e-mail i numeru konta. Prosimy o użycie linku dostarczonego w wiadomości e-mail wysłanej przez Ebury",
    ro: "Nu s-au găsit date pentru adresa de e-mail și numărul de cont date. Vă rugăm să utilizați linkul furnizat în e-mailul trimis de Ebury",
    gr: "Δεν βρέθηκαν δεδομένα για το δεδομένο email και τον αριθμό λογαριασμού. Χρησιμοποιήστε τον σύνδεσμο που παρέχεται στο email που έστειλε η Ebury",
    //TODO: add new language here
  },
  GENERAL_ERROR: {
    en: "Don't worry, your progress has been saved, and our team has been notified. Sorry for the inconvenience!",
    es: "No se preocupe, su progreso se ha guardado y nuestro equipo ha sido notificado. Sentimos las molestias.",
    nl: "Geen zorgen, de voortgang is opgeslagen en ons team is op de hoogte gesteld. Excuses voor het ongemak!",
    fr: "Ne vous inquiétez pas, votre progression a été sauvegardée, et votre équipe a été informée. Desolée pour les désagréments",
    pt: "Não se preocupe, o seu progresso foi guardado e a nossa equipa foi notificada. Pedimos desculpa pela inconveniência.",
    it: "Non preoccuparti, i tuoi progressi sono stati salvati e il nostro team è stato avvisato. Ci scusiamo per l'inconveniente!",
    de: "Keine Sorge, Ihr Fortschritt wurde gespeichert und unser Team wurde benachrichtigt. Entschuldigen Sie die Unannehmlichkeiten!",
    pl: "Uprzejmie informujemy, że wprowadzone dane zostały zapisane, a nasz zespół został już powiadomiony o zaistniałej sytuacji. Przepraszamy za wszelkie niedogodności, które mogły wyniknąć.",
    ro: "Nu vă faceți griji, progresul dvs. a fost salvat, iar echipa noastră a fost notificată. Ne cerem scuze pentru neplăcerile create!",
    gr: "Μην ανησυχείτε, η πρόοδός σας έχει αποθηκευτεί και η ομάδα μας έχει ειδοποιηθεί. Λυπούμαστε για την ταλαιπωρία!",
    //TODO: add new language here
  },
  ERROR_OCCURRED: {
    en: "An error has occurred",
    es: "Ha ocurrido un error",
    nl: "Er is een fout opgetreden",
    fr: "Une erreur s'est produite",
    pt: "Ocorreu um erro",
    it: "Si è verificato un errore",
    de: "Ein Fehler ist aufgetreten",
    pl: "Wystąpił błąd",
    ro: "A apărut o eroare",
    gr: "Παρουσιάστηκε σφάλμα",
    //TODO: add new language here
  },
  NO_ACCOUNT_NUMBER: {
    en: "No account number found. Please use the link provided in the email sent by Ebury",
    es: "No se ha podido encontrar el número de cuenta. Utilice el enlace enviado a su correo electrónico por Ebury.",
    nl: "Geen rekeningnummer gevonden. Gebruik de link in de e-mail die Ebury heeft verzonden",
    fr: "Pas de numéro de compte trouvé. Veuillez utiliser le lien fourni dans le mail envoyé par Ebury.",
    pt: "Não foram encontrados dados para o e-mail e número de conta fornecidos. Por favor, utilize o link fornecido no e-mail enviado pela Ebury",
    it: "Nessun numero di conto trovato. Si prega di utilizzare il link fornito nell'email inviata da Ebury.",
    de: "Keine Kontonummer gefunden. Bitte verwenden Sie den per E-Mail bereitgestellten Link.",
    pl: "Nie znaleziono numeru konta. Prosimy o kliknięcie linku, który znajduje się w otrzymanej wiadomości e-mail.",
    ro: "Nu s-a găsit niciun număr de cont. Vă rugăm să utilizați linkul furnizat prin e-mail.",
    gr: "Δεν βρέθηκε αριθμός λογαριασμού. Χρησιμοποιήστε τον σύνδεσμο που παρέχεται μέσω email.",
    //TODO: add new language here
  },
  NO_EMAIL: {
    en: "No email found",
    es: "No se ha encontrado ningún correo electrónico",
    nl: "Geen e-mailadres gevonden",
    fr: "Pas d'adresse mail trouvée",
    pt: "Nenhum e-mail encontrado",
    it: "Nessuna e-mail trovata",
    de: "Keine E-Mail gefunden",
    pl: "Nie znaleziono adresu e-mail",
    ro: "Nu s-a găsit niciun e-mail",
    gr: "Δεν βρέθηκε email",
    //TODO: add new language here
  },
  USE_EBURY_EMAIL: {
    en: "Please use the link provided by email",
    es: "Utilice el enlace proporcionado por correo electrónico",
    nl: "Gebruik de link die per e-mail is verstrekt",
    fr: "Veuillez utiliser le lien fourni par mail",
    pt: "Por favor utilize o link fornecido por e-mail",
    it: "Utilizza il link fornito tramite e-mail",
    de: "Bitte verwenden Sie den per E-Mail bereitgestellten Link",
    pl: "Prosimy o kliknięcie linku, który znajduje się w otrzymanej wiadomości e-mail.",
    ro: "Vă rugăm să utilizați linkul furnizat prin e-mail",
    gr: "Χρησιμοποιήστε τον σύνδεσμο που παρέχεται μέσω email",
    //TODO: add new language here
  },
  INVALID_LINK: {
    en: "Invalid link",
    es: "Enlace no válido",
    fr: "Lien invalide",
    nl: "Ongeldige link",
    pt: "Link inválido",
    it: "Link non valido",
    de: "Ungültiger Link",
    pl: "Nieprawidłowy link",
    ro: "Link nevalid",
    gr: "Μη έγκυρος σύνδεσμος",
    //TODO: add new language here
  },
  SIGN_IN_FAILED: {
    en: "Sign in failed",
    es: "Fallo al iniciar sesión",
    nl: "Inloggen mislukt",
    fr: "L´identification a échoué",
    pt: "Falha ao entrar",
    it: "Accesso non riuscito",
    de: "Anmeldung fehlgeschlagen",
    pl: "Nie udało się zalogować",
    ro: "Conectare nereușită",
    gr: "Η σύνδεση απέτυχε",
    //TODO: add new language here
  },
  SIGN_IN_FAILED_REFRESH: {
    en: "Sign in with email failed. Please refresh and try again",
    es: "El inicio de sesión con su correo eletrónico ha fallado. Por favor, actualice y pruebe de nuevo.",
    nl: "Aanmelden met e-mailadres is mislukt. Vernieuw de pagina en probeer het opnieuw",
    fr: "L´identification par mail a échoué. Veuillez rafraîchir la page et essayer de nouveau",
    pt: "Falha ao iniciar sessão com e-mail. Atualize e tente novamente",
    it: "Accesso con e-mail non riuscito. Aggiorna e riprova",
    de: "Anmeldung mit E-Mail fehlgeschlagen. Bitte aktualisieren und erneut versuchen",
    pl: "Nie udało się zalogować za pomocą adresu e-mail. Odśwież i spróbuj ponownie",
    ro: "Conectare cu e-mail nereușită. Reîmprospătați pagina și încercați din nou",
    gr: "Η σύνδεση με email απέτυχε. Κάντε ανανέωση και δοκιμάστε ξανά",
    //TODO: add new language here
  },
  EMAIL_NOT_IN_ACCOUNT: {
    en: "The email you are trying to sign in with is not associated with the account number. Please, click ok and try signing in with a different email",
    es: "El correo electrónico con el que intenta iniciar sesión no está asociado con el número de cuenta. Por favor, haga clic en ok e intente iniciar sesión con un correo electrónico diferente.",
    nl: "De e-mail waarmee u probeert in te loggen is niet gekoppeld aan het rekeningnummer. Klik op ok en probeer in te loggen met een ander e-mailadres",
    fr: "L´adresse mail avec laquelle vous essayez de vous identifier n´est pas associée au numéro de compte. Veuillez cliquer sur ok et essayer de vous identifier avec une adresse mail différente",
    pt: "O e-mail com o qual você está tentando entrar não está associado ao número da conta. Por favor, clique em ok e tente entrar com um e-mail diferente",
    it: "L'email con cui stai cercando di accedere non è associato al numero di conto. Clicca su ok e prova ad accedere con un'email diversa",
    de: "Die E-Mail, mit der Sie sich anmelden möchten, ist nicht mit der Kontonummer verknüpft. Bitte klicken Sie auf OK und versuchen Sie es mit einer anderen E-Mail-Adresse erneut",
    pl: "E-mail, którego próbujesz użyć do logowania, nie jest powiązany z numerem konta. Kliknij OK i spróbuj zalogować się za pomocą innego adresu e-mail",
    ro: "E-mailul pe care încercați să vă conectați nu este asociat cu numărul de cont. Vă rugăm să faceți clic pe ok și să încercați să vă conectați cu un e-mail diferit",
    gr: "Το email με το οποίο προσπαθείτε να συνδεθείτε δεν είναι συνδεδεμένο με τον αριθμό λογαριασμού. Κάντε κλικ στο ok και προσπαθήστε να συνδεθείτε με διαφορετικό email",
    //TODO: add new language here
  },
};

export const idDocsDescription = {
  en: `Please provide a valid and certified ID document. ID documents should be in date and government issued and contain at least full name, photograph and date of birth. Certifications must be carried out by professionals authorised to do so in your country, be signed and contain the details of the certifier.  If you prefer to use an electronic identity verification method please contact your relationship manager or KYC@ebury.com`,
  es: `Por favor, proporcione una copia certificada del Documento De Identidad. El documento de identidad debe estar en vigor e incluir, por lo menos, nombre completo, fotografía y fecha de nacimiento. Las certificaciones deben llevarse a cabo por profesionales autorizados para ello siguiendo la normativa de su país, y deben estar firmados e incluir los detalles del certificador. Si prefiere usar un método de verificación de identidad electrónico, por favor contacte a su gestor o a kyc@ebury.com`,
  nl: `Graag ontvangen wij een geldig en gecertificeerd identiteitsbewijs. Identiteitsdocumenten moeten de datum en de door de overheid afgegeven datum hebben en ten minste de volledige naam, foto en geboortedatum bevatten. Certificeringen moeten worden uitgevoerd door professionals die daartoe in uw land geautoriseerd zijn, de documenten moeten ondertekend zijn en de gegevens van de certificeerder bevatten. Als u liever een elektronische identiteitsverificatiemethode gebruikt, neem dan contact op met uw relatiebeheerder of kyc@ebury.com`,
  fr: `Veuillez fournir une pièce d'identité valide et certifiée. Les documents d'identité doivent être datés et délivrés par le Gouvernement et contenir au moins le nom complet, la photographie et la date de naissance. Les certifications doivent être réalisées par des professionnels habilités à le faire dans votre pays, être signées et contenir les coordonnées du certificateur. Si vous préférez utiliser une méthode de vérification d'identité électronique, veuillez contacter votre responsable relationnel ou kyc@ebury.com`,
  pt: `Providencie uma cópia certificada do seu documento de identidade. O documento de identidade deve ser válido e incluir, pelo menos, o nome completo, a fotografia e a data de nascimento. As certificações devem ser realizadas por profissionais autorizados a fazê-lo em conformidade com a regulamentação do seu país e devem ser assinadas e incluir os dados do certificador. Se preferir utilizar um método eletrónico de verificação de identidade, contacte o seu gestor de conta ou kyc@ebury.com`,
  it: "Si prega di fornire un documento d'identità valido e certificato. I documenti d'identità devono essere in corso di validità e rilasciati dal governo, e devono contenere almeno nome completo, fotografia e data di nascita. Le certificazioni devono essere eseguite da professionisti autorizzati a farlo nel vostro paese, essere firmate e contenere i dettagli del certificatore. Se preferite utilizzare un metodo di verifica dell'identità elettronica, si prega di contattare il vostro relationship manager o KYC@ebury.com",
  de: "Bitte legen Sie einen gültigen und beglaubigten Ausweis vor. Ausweisdokumente sollten aktuell und von einer Regierungsbehörde ausgestellt sein und mindestens den vollständigen Namen, ein Foto und das Geburtsdatum enthalten. Beglaubigungen müssen von in Ihrem Land dazu befugten Fachleuten durchgeführt werden, unterzeichnet sein und die Angaben des Beglaubigers enthalten. Wenn Sie eine elektronische Methode zur Identitätsprüfung bevorzugen, wenden Sie sich bitte an Ihren Kundenbetreuer oder an KYC@ebury.com",
  pl: "Prosimy o dostarczenie ważnego i poświadczonego dokumentu tożsamości. Dokumenty tożsamości powinny być aktualne, wydane przez organ państwowy i zawierać co najmniej imię i nazwisko, zdjęcie oraz datę urodzenia. Poświadczenia muszą być wykonane przez profesjonalistów upoważnionych do tego w Państwa kraju, być podpisane i zawierać dane osoby poświadczającej. Jeśli wolisz skorzystać z elektronicznej metody weryfikacji tożsamości, skontaktuj się ze swoim menedżerem ds. relacji lub pod adresem KYC@ebury.com",
  ro: "Vă rugăm să furnizați un document de identitate valabil și certificat. Documentele de identitate trebuie să fie la zi, emise de o autoritate guvernamentală și să conțină cel puțin numele complet, fotografia și data nașterii. Certificările trebuie efectuate de profesioniști autorizați în țara dumneavoastră, să fie semnate și să conțină detaliile certificatorului. Dacă preferați să utilizați o metodă electronică de verificare a identității, vă rugăm să contactați managerul de relații sau KYC@ebury.com",
  gr: "Παρακαλείστε να προσκομίσετε ένα έγκυρο και πιστοποιημένο έγγραφο ταυτότητας. Τα έγγραφα ταυτότητας πρέπει να είναι εν ισχύ, εκδοθέντα από κρατική αρχή και να περιέχουν τουλάχιστον ονοματεπώνυμο, φωτογραφία και ημερομηνία γέννησης. Οι πιστοποιήσεις πρέπει να διενεργούνται από επαγγελματίες εξουσιοδοτημένους να το πράττουν στη χώρα σας, να είναι υπογεγραμμένες και να περιέχουν τα στοιχεία του πιστοποιούντος. Εάν προτιμάτε να χρησιμοποιήσετε μια ηλεκτρονική μέθοδο επαλήθευσης ταυτότητας, επικοινωνήστε με τον υπεύθυνο πελατειακών σχέσεων ή με το KYC@ebury.com",
  //TODO: add new language here
};

export const addressProofDescription = {
  en: "Proof of address documents should be dated within the last 3 months and issued by an independent verifiable source.",
  es: "Los justificantes de domicilio deben haber sido emitidos en los últimos 3 meses y por una fuente independiente y verificable.",
  nl: "Bewijs van adresdocumenten moeten binnen de afgelopen drie maanden zijn gedateerd en zijn afgegeven door een onafhankelijke, verifieerbare bron.",
  fr: "Les justificatifs de domicile doivent être datés de moins de 3 mois et délivrés par une source indépendante vérifiable.",
  pt: "Os comprovativos de endereço devem ter a data dos últimos 6 meses e emitidos por uma fonte independente e verificável.",
  it: "I documenti di prova dell'indirizzo devono essere datati negli ultimi 3 mesi e rilasciati da una fonte indipendente e verificabile.",
  de: "Adressnachweise sollten innerhalb der letzten 3 Monate datiert und von einer unabhängigen, überprüfbaren Quelle ausgestellt sein.",
  pl: "Dokumenty potwierdzające adres powinny być datowane w ciągu ostatnich 3 miesięcy i wydane przez niezależne, weryfikowalne źródło.",
  ro: "Documentele doveditoare ale adresei trebuie să fie datate în ultimele 3 luni și emise de o sursă independentă și verificabilă.",
  gr: "Τα έγγραφα απόδειξης διεύθυνσης πρέπει να έχουν ημερομηνία εντός των τελευταίων 3 μηνών και να έχουν εκδοθεί από ανεξάρτητη, επαληθεύσιμη πηγή.",
  //TODO: add new language here
};

export const divider: PeriodicReviews.WebApp.ElementData = {
  id: "divider",
  type: "divider",
  title: {
    en: "divider",
  },
};

export const getRelationDivider = (
  relationNumber: string,
): PeriodicReviews.WebApp.ElementData => {
  return {
    id: `relation_${relationNumber}_divider`,
    type: "divider",
    title: {
      en: "divider",
    },
  };
};

/**
 * FCA: Financial Conduct Authority - They regulate financial services firms and financial markets in the UK. https://www.fca.org.uk/
 */
export const fcaCountries = [
  "United Kingdom",
  "Switzerland",
  "Australia",
  "Canada",
  "Hong Kong",
  "United Arab Emirates",
];

/**
 * NBB: National Bank of Belgium - Regulatory authority for Belgium impacting all our European entities. https://www.nbb.be/en
 */
export const nbbCountries = [
  "Belgium",
  "Czechia",
  "France",
  "Germany",
  "Greece",
  "Italy",
  "Spain",
  "Poland",
  "Netherlands",
  "Luxembourg",
  "Portugal",
  "Bulgaria",
  "Romania",
  "Ireland",
  "Lithuania",
];

export const allCountries = [...fcaCountries, ...nbbCountries];
